import { createSlice } from '@reduxjs/toolkit';
import { ProductSetsListStateType } from 'src/types/productSetsList';

const initialState: ProductSetsListStateType = {
    data: null,
    loading: false,
    error: false,
};
export const productSetsListSlice = createSlice({
    name: 'productSetsList',
    initialState,
    reducers: {
        getProductSetsListFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getProductSetsListFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getProductSetsListFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getProductSetsListFetch,
    getProductSetsListFetchSuccess,
    getProductSetsListFetchFailure,
} = productSetsListSlice.actions;

export default productSetsListSlice.reducer;
